export const LOCATION_DISTANCES = [5, 10, 25, 50];
